import * as React from "react";

export const MermaidIcon = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Flowchart/diagram symbol - nodes and connections */}
    <circle cx="8" cy="8" r="2" />
    <circle cx="16" cy="8" r="2" />
    <circle cx="8" cy="16" r="2" />
    <circle cx="16" cy="16" r="2" />
    <path d="M10 8h4" />
    <path d="M8 10v4" />
    <path d="M16 10v4" />
    <path d="M10 16h4" />
  </svg>
);

export default MermaidIcon;
